import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Extracted OCR Information", -1)
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-10" }
const _hoisted_9 = { class: "mb-8" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, "Front", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed" }, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "mb-8"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, "Back", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed" }, null, -1)
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", null, "Raw Results", -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("  \n                ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("\n                ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_SummaryCard = _resolveComponent("SummaryCard")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.$modals.VIEW_OCR_MODAL,
    ref: "ocrModalRef",
    class: "modal fade",
    tabindex: "-1",
    "aria-hidden": "true",
    backdrop: "static",
    keyboard: "false"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "btn btn-icon btn-sm btn-active-icon-primary",
            id: `${_ctx.$modals.VIEW_OCR_MODAL}_close`,
            "data-bs-dismiss": "modal"
          }, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ], 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedMeta.front || {}, (value, key) => {
              return (_openBlock(), _createBlock(_component_SummaryCard, {
                key: key,
                title: _ctx.separateWords(key as unknown as string),
                "right-text": value,
                subtitle: _ctx.separateWords(key as unknown as string),
                icon: _ctx.getRandomIcon(),
                variant: 'bg-light-primary',
                color: _ctx.getRandomColor()
              }, null, 8, ["title", "right-text", "subtitle", "icon", "color"]))
            }), 128)),
            _hoisted_11
          ]),
          (Object.keys(_ctx.displayedMeta.back || {}).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedMeta.back, (value, key) => {
                  return (_openBlock(), _createBlock(_component_SummaryCard, {
                    key: key,
                    title: _ctx.separateWords(key as unknown as string),
                    "right-text": value,
                    subtitle: _ctx.separateWords(key as unknown as string),
                    icon: _ctx.getRandomIcon(),
                    variant: 'bg-light-primary',
                    color: _ctx.getRandomColor()
                  }, null, 8, ["title", "right-text", "subtitle", "icon", "color"]))
                }), 128)),
                _hoisted_14
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("pre", null, [
                  _hoisted_17,
                  _createElementVNode("code", null, "\n                  " + _toDisplayString(_ctx.meta) + "\n                ", 1),
                  _hoisted_18
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 8, _hoisted_1))
}